import request from '@/utils/request'export function apply(data) {	return request({		url: '/businessLoan/apply',		method: 'post',		data: data	})}